// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateSystemSelectedClaimsModalVisibility = (state, action) => action.isVisible;

export default (state = getDefaultState().isSystemSelectedClaimsModalVisible, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_PREPARE_AUDIT_SYSTEM_SELECTED_CLAIMS_MODAL_VISIBILITY]: updateSystemSelectedClaimsModalVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/reducers/system-selected-claims-modal-visibility.js